
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/yoga-meditation/yoga-teacher-training/hatha-yoga-teacher-training",
      function () {
        return require("private-next-pages/[region]/[language]/yoga-meditation/yoga-teacher-training/hatha-yoga-teacher-training/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/yoga-meditation/yoga-teacher-training/hatha-yoga-teacher-training"])
      });
    }
  